// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface XRfqRequestQuoteStateType {
    isCreatingOrRequestingQuote: boolean;
}

export const initialXRfqRequestQuoteState: XRfqRequestQuoteStateType = {
    isCreatingOrRequestingQuote: false,
};

const reducer = {
    "xRfqRequestQuote/BeginCreateOrRequestQuote": (draft: Draft<XRfqRequestQuoteStateType>) => {
        draft.isCreatingOrRequestingQuote = true;
    },
    "xRfqRequestQuote/CompleteCreateOrRequestQuote": (draft: Draft<XRfqRequestQuoteStateType>) => {
        draft.isCreatingOrRequestingQuote = false;
    },
};

const xRfqRequestQuote = createTypedReducerWithImmer(initialXRfqRequestQuoteState, reducer);

(reducers as any).xRfqRequestQuote = xRfqRequestQuote;

export type xRfqRequestQuoteState = {
    xRfqRequestQuote: XRfqRequestQuoteStateType;
} & ApplicationState;

type xRfqRequestQuoteReducers = {
    [key: string]: typeof xRfqRequestQuote;
};

export type xRfqRequestQuoteActions = Parameters<xRfqRequestQuoteReducers[keyof xRfqRequestQuoteReducers]>[1] | AnyAction;
